// ISDP CUSTOM: Entire file — Route ref for landscape plugin
import { createRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'landscape',
});
